<template>
  <div>
    <p class="text-sm text-slate-500">{{ label }}</p>
    <p class="text-base" :class="{ 'roboto-mono-400': mono }">{{ displayValue }}</p>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  label: { type: String, required: true },
  value: { type: [String, Number, Boolean], default: null },
  mono: Boolean,
})

const displayValue = computed(() => {
  if (props.value === null || props.value === undefined || props.value === '') return '-'
  return props.value
})
</script>
